import { render, staticRenderFns } from "./website-info.vue?vue&type=template&id=ca5a182c&scoped=true"
import script from "./website-info.vue?vue&type=script&lang=js"
export * from "./website-info.vue?vue&type=script&lang=js"
import style0 from "./website-info.vue?vue&type=style&index=0&id=ca5a182c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5a182c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca5a182c')) {
      api.createRecord('ca5a182c', component.options)
    } else {
      api.reload('ca5a182c', component.options)
    }
    module.hot.accept("./website-info.vue?vue&type=template&id=ca5a182c&scoped=true", function () {
      api.rerender('ca5a182c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/website-info.vue"
export default component.exports